"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5796 5.5286C9.3634 4.5556 10.5332 4 11.9889 4c1.4549 0 2.6284.555 3.4174 1.525.7725.9496 1.099 2.2002 1.0936 3.475.5523 0 1.0001.4477 1.0001 1 0 .6671-.6746 1.1515-1.3012.9538C15.5916 12.803 13.9572 14 11.9889 14c-1.9662 0-3.591-1.1971-4.1913-3.045C7.1715 11.1498 6.5 10.6655 6.5 10c0-.5523.4477-1 1-1 0-1.2303.2944-2.4967 1.0796-3.4714zm1.5575 1.2547c-.495.6145-.6392 1.4482-.637 2.2167h4.9998c.0022-.7693-.147-1.6006-.6451-2.213-.3759-.4621-.9579-.787-1.8659-.787-.9073 0-1.482.3241-1.8518.7833z"
  }), _react.default.createElement("path", {
    d: "M5.5248 18.9115C4.9633 19.8671 5 20.9335 5 22H3c0-1.4341.0492-2.8231.8004-4.1017C5.0217 15.8196 7.3854 15 9.6914 15h4.6172c2.3067 0 4.6694.8192 5.891 2.8983C20.9508 19.1769 21 20.5659 21 22h-2c0-1.0665.0367-2.1329-.5248-3.0885C17.6191 17.4543 15.8977 17 14.3086 17H9.6914c-1.589 0-3.3105.4543-4.1666 1.9115z"
  })];
};

exports.default = _default;